import React from 'react';
import { getMessage } from 'util/locale';

type RevertButtonProps = {
  onClick: () => void;
}

export const RevertButton = ({ onClick }: RevertButtonProps) => {
  return (
    <button type="button" className="revert-button" onClick={onClick}>
      {getMessage('revert-button')}
    </button>
  );
};
